// store/filtersSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type PageFilterState = {
  filters: Record<string, any>;
  switch?: boolean;
  search: string;
};

type FiltersState = Record<string, PageFilterState>;

const initialState: FiltersState = {};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setPageFilters: (state, action: PayloadAction<{ pageKey: string; filters: Record<string, any> }>) => {
      const { pageKey, filters } = action.payload;
      if (!state[pageKey]) {
        state[pageKey] = { filters: {}, search: "" };
      }
      state[pageKey].filters = {
        ...state[pageKey].filters,
        ...filters,
      };
    },
    setPageSearch: (state, action: PayloadAction<{ pageKey: string; search: string }>) => {
      const { pageKey, search } = action.payload;
      if (!state[pageKey]) {
        state[pageKey] = { filters: {}, search: "" };
      }
      state[pageKey].search = search;
    },
    setPageSwitch: (state, action: PayloadAction<{ pageKey: string; value: boolean }>) => {
      const { pageKey, value } = action.payload;
      if (!state[pageKey]) {
        state[pageKey] = { filters: {}, search: "" };
      }
      state[pageKey].switch = value;
    },
    clearPageFilters: (state, action: PayloadAction<{ pageKey: string }>) => {
      const { pageKey } = action.payload;
      if (state[pageKey]) {
        state[pageKey].filters = {};
      }
    },
    clearPageSearch: (state, action: PayloadAction<{ pageKey: string }>) => {
      const { pageKey } = action.payload;
      if (state[pageKey]) {
        state[pageKey].search = "";
      }
    },
    clearPageSwitch: (state, action: PayloadAction<{ pageKey: string }>) => {
      const { pageKey } = action.payload;
      if (state[pageKey]) {
        delete state[pageKey].switch;
      }
    },
    clearPageState: (state, action: PayloadAction<{ pageKey: string }>) => {
      const { pageKey } = action.payload;
      delete state[pageKey];
    },
    clearAllPagesState: () => {
      return {}; // Reset the entire slice
    },
  },
});

export const {
  setPageFilters,
  setPageSearch,
  setPageSwitch,
  clearPageFilters,
  clearPageSearch,
  clearPageSwitch,
  clearPageState,
  clearAllPagesState
} = filtersSlice.actions;

export type { PageFilterState, FiltersState };
export default filtersSlice.reducer;
